<template>
  <!-- 

  [ type a 보더 옵션 / default : 없음 ]
  .border

  [ type a 간격 옵션 / default : 없음 ]
  .spacing--sm
  .spacing--md
  .spacing--lg

  -->
  <footer
    class="footer-type-a spacing--lg"
    :class="themeClasses('footer')"
  >
    <logo
      class="logo--xs"
      :reverse="true"
    ></logo>
    <component-view :seq="theme.footer"></component-view>

    <!-- <div v-html="theme.footer"></div> -->
  </footer>
</template>

<script>
import footer from './js/footer'
export default {
  mixins: [footer]
}
</script>
